{
  "metadata": {
    "id": "arctic-light",
    "name": "Arctic",
    "description": "Собственная тема Synth «Arctic» (light)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.446,
      "paletteMaxS": 0.522,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.8,
      "syntaxVsTextMinDeltaE": 13.6,
      "chartsMinDeltaE": 39.0,
      "textSeparationDeltaE": 22.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 3.9
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 17.7
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#0E7490",
      "hover": "#0d6882",
      "active": "#0b5f76",
      "foreground": "#ffffff",
      "muted": "#0e749080",
      "emphasis": "#0E7490"
    },
    "surface": {
      "background": "#F2F7FB",
      "foreground": "#0F172A",
      "muted": "#c3c9d1",
      "mutedForeground": "#3b4654",
      "elevated": "#acb3bd",
      "elevatedForeground": "#0F172A",
      "raised": "#9198a4",
      "raisedForeground": "#0F172A",
      "overlay": "#f2f7fb33",
      "subtle": "#dbe0e6"
    },
    "interactive": {
      "border": "#8a919e",
      "borderHover": "#b2b8c0",
      "borderFocus": "#0E7490",
      "selection": "#0f172a24",
      "selectionForeground": "#0F172A",
      "focus": "#0e749059",
      "focusRing": "#0e749047",
      "cursor": "#0b1220",
      "hover": "#0f172a17",
      "active": "#0f172a24"
    },
    "status": {
      "error": "#BE123C",
      "errorForeground": "#ffffff",
      "errorBackground": "#be123c1a",
      "errorBorder": "#be123c59",
      "warning": "#B45309",
      "warningForeground": "#ffffff",
      "warningBackground": "#b453091a",
      "warningBorder": "#b4530959",
      "success": "#047857",
      "successForeground": "#ffffff",
      "successBackground": "#0478571a",
      "successBorder": "#04785759",
      "info": "#0369A1",
      "infoForeground": "#ffffff",
      "infoBackground": "#0369a11a",
      "infoBorder": "#0369a159"
    },
    "pr": {
      "open": "#047857",
      "draft": "#475465",
      "blocked": "#B45309",
      "merged": "#1D4ED8",
      "closed": "#BE123C"
    },
    "syntax": {
      "base": {
        "background": "#c3c9d1",
        "foreground": "#0F172A",
        "comment": "#485464",
        "keyword": "#035988",
        "string": "#0c5f59",
        "number": "#6825d2",
        "function": "#002f48",
        "variable": "#1b48c6",
        "type": "#1E40AF",
        "operator": "#475465"
      },
      "tokens": {
        "commentDoc": "#485464",
        "stringEscape": "#475465",
        "keywordImport": "#035988",
        "storageModifier": "#035988",
        "functionCall": "#002f48",
        "method": "#002f48",
        "variableProperty": "#002f48",
        "variableOther": "#1b48c6",
        "variableGlobal": "#6825d2",
        "variableLocal": "#475465",
        "parameter": "#1b48c6",
        "constant": "#6825d2",
        "class": "#1E40AF",
        "className": "#1E40AF",
        "interface": "#1E40AF",
        "struct": "#1E40AF",
        "enum": "#1E40AF",
        "typeParameter": "#1E40AF",
        "namespace": "#1E40AF",
        "module": "#035988",
        "tag": "#035988",
        "jsxTag": "#035988",
        "tagAttribute": "#002f48",
        "tagAttributeValue": "#0c5f59",
        "boolean": "#6825d2",
        "decorator": "#035988",
        "label": "#002f48",
        "regexp": "#0c5f59"
      }
    },
    "charts": {
      "series": [
        "#0E7490",
        "#0334a1",
        "#047857",
        "#B45309",
        "#BE123C"
      ]
    },
    "chat": {
      "background": "#F2F7FB",
      "userMessage": "#0F172A",
      "userMessageBackground": "#acb3bd",
      "assistantMessage": "#0F172A",
      "assistantMessageBackground": "#c3c9d1",
      "timestamp": "#475465",
      "divider": "#8a919e",
      "typing": "#475465"
    },
    "loading": {
      "spinner": "#0E7490",
      "spinnerTrack": "#c3c9d1",
      "skeleton": "#c3c9d1",
      "shimmer": "#b8bec7"
    },
    "tools": {
      "background": "#c3c9d1",
      "border": "#8a919e",
      "headerHover": "#bac0c9",
      "icon": "#0E7490",
      "title": "#0F172A",
      "description": "#475465",
      "edit": {
        "added": "#047857",
        "addedBackground": "#0478571a",
        "removed": "#BE123C",
        "removedBackground": "#be123c1a",
        "modified": "#0369A1",
        "modifiedBackground": "#0369a11a",
        "lineNumber": "#475465"
      }
    },
    "markdown": {
      "heading1": "#0F172A",
      "heading2": "#0F172A",
      "heading3": "#0F172A",
      "heading4": "#0F172A",
      "link": "#0E7490",
      "linkHover": "#0d6882",
      "inlineCode": "#0c5f59",
      "inlineCodeBackground": "#c3c9d1",
      "blockquote": "#475465",
      "blockquoteBorder": "#8a919e",
      "listMarker": "#0e7490bf",
      "bold": "#0F172A",
      "italic": "#0f172ae6",
      "strikethrough": "#475465",
      "hr": "#8a919e"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a393f",
        "foreground": "#ffffff",
        "contrast": 7.67
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c67756",
        "foreground": "#000000",
        "contrast": 6.17
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ad9045",
        "foreground": "#000000",
        "contrast": 6.85
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bcce63",
        "foreground": "#000000",
        "contrast": 12.15
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#678f41",
        "foreground": "#000000",
        "contrast": 5.58
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#62cb5f",
        "foreground": "#000000",
        "contrast": 10.23
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#67c288",
        "foreground": "#000000",
        "contrast": 9.65
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e78",
        "foreground": "#000000",
        "contrast": 5.38
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#60bdca",
        "foreground": "#000000",
        "contrast": 9.63
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3f798c",
        "foreground": "#ffffff",
        "contrast": 4.86
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5b81bb",
        "foreground": "#000000",
        "contrast": 5.3
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#323786",
        "foreground": "#ffffff",
        "contrast": 10.36
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#7c53c1",
        "foreground": "#ffffff",
        "contrast": 5.43
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c659c4",
        "foreground": "#000000",
        "contrast": 5.63
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b7b",
        "foreground": "#ffffff",
        "contrast": 7.02
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c5567e",
        "foreground": "#000000",
        "contrast": 5.01
      }
    ]
  }
}
